














import { Component, Prop, Vue } from 'vue-property-decorator';
import BaseComponent from './BaseComponent.vue';
import { EVENTS } from '@/author/constants';
import { generateHash } from '@/author/components/helper/hash';

type FlashcardTheme = {
  background?: string;
  color?: string;
};
@Component
export default class Flashcard extends BaseComponent {
  @Prop() color!: string;
  @Prop() backgroundColor!: string;
  @Prop() title!: string;
  @Prop() description!: string;
  @Prop() theme!: string;
  @Prop({ default: '' }) frontBackground!: string;
  @Prop({ default: '' }) backBackground!: string;
  @Prop({ default: '' }) frontColor!: string;
  @Prop({ default: '' }) backColor!: string;

  isFlipped: boolean = false;

  public $refs!: {
    flashcard: HTMLElement;
    back: HTMLElement;
  };

  created() {
    this.$parent.$on('setup-modal', (hash: number) => {
      if (this.hash === hash) this.isFlipped = true;
    });
  }

  computedTheme(side: string) {
    let theme: FlashcardTheme = {};
    if (side == 'front') {
      theme.background = this.frontBackground || this.backgroundColor;
      theme.color = this.frontColor || this.color;
    }
    if (side == 'back') {
      theme.background = this.backBackground || this.backgroundColor;
      theme.color = this.backColor || this.color;
    }
    if (this.theme === 'horizontal-accent') {
      return {
        backgroundColor: '#fff',
        color: this.backColor || this.color
      };
    }
    return theme;
  }
  computedThemeAccent() {
    return {
      backgroundColor: this.backgroundColor,
      color: this.color
    };
  }
  flip() {
    this.isFlipped = true;
    this.$parent.$emit(EVENTS.COMPLETED, this.hash);
    this.$emit('modalcompleted');
    if (this.isFlipped && this.$refs.back) {
      setTimeout(() => {
        this.$refs.back.focus();
      }, 700);
    }
  }
  public isCompleted(): boolean {
    return this.isFlipped;
  }

  get hash(): number {
    return generateHash(
      this.title +
        this.description +
        this.theme +
        this.$refs.flashcard.innerHTML
    );
  }
}
